import React from 'react';
import PropTypes from 'prop-types';
import { find } from "lodash"
import {
  COMPONENT_TYPE,
  checkSlidersCorrect,
  checkAllSliderGroupsCorrect,
} from '@learningblocks/protocol-constants/lib/Utilities';
import CorrectIcon from '@learningblocks/exp-constants/lib/Images/correct-icon.svg';
import IncorrectIcon from '@learningblocks/exp-constants/lib/Images/incorrect-icon.svg';
import {Image, Button} from '@learningblocks/exp-components';
import './style.scss';
import { saveFeedbackToAirtable } from '@learningblocks/exp-constants/lib/Utilities/AirtableSaveFeedback';

export function QuestionFooter(props) {
  function getFeedback(slidersCorrect) {
    let src = IncorrectIcon,
      alt = 'feedbackIncorrect';
    if (slidersCorrect) {
      src = CorrectIcon;
      alt = 'feedbackCorrect';
    }
    return <Image className='feedback-icon' src={src} alt={alt} />;
  }

  function renderFeedback() {
    let feedback = null;
    if (props.type === COMPONENT_TYPE.DNDQ_COLOR && props.showFeedback) {
      feedback = getFeedback(checkSlidersCorrect(props.sliders));
    } else if (
      props.type === COMPONENT_TYPE.GROUPED_DNDQ &&
      props.showFeedback
    ) {
      feedback = getFeedback(checkAllSliderGroupsCorrect(props.sliderGroups));
    } else {
      feedback = null;
    }
    return feedback;
  }

  function getTotalAttempts() {
    if (props.totalAttempts === -10) {
      return 'Unlimited';
    } else {
      return props.totalAttempts;
    }
  }

  function isSubmitDisabled() {
    if (props.complete) {
      return true;
    } else if (
      props.type === COMPONENT_TYPE.CSCQ ||
      props.type === COMPONENT_TYPE.CSCQ_COLOR
    ) {
      if (props.typedOptions)
        return CSCQHasUnsubmittedOption(props.typedOptions);
      else return CSCQHasUnsubmittedOption(props.options);
    } else if (props.type === COMPONENT_TYPE.GROUPED_CSCQ) {
        return GroupedCSCQHasUnsubmittedOption(props.groupedOptions1, props.groupedOptions2, props.answerId[0], props.answerId[1]);
    } else if (props.type === COMPONENT_TYPE.DDQ) {
      return DDQHasUntouchedDropdown();
    } else if (props.type === COMPONENT_TYPE.DNDQ_COLOR) {
      return DNDQHasNoUnsubmittedUpdates();
    } else if (props.type === COMPONENT_TYPE.GROUPED_DNDQ) {
      return GroupedDNDQHasNoUnsubmittedUpdate();
    } else if (props.type === COMPONENT_TYPE.MSCQ) {
      return MSCQHasUnsubmittedChanges();
    } else if (props.type === COMPONENT_TYPE.OEQ) {
      return OEQHasNoUnsubmittedUpdates();
    } else if (props.type === COMPONENT_TYPE.NEQ) {
      return NEQHasNoUnsubmittedUpdates();
    } else {
      return true;
    }
  }

  function DDQHasUntouchedDropdown() {
    const hasUntouchedStep = props.answerSteps.reduce((boolVal, step) => {
      if (step.droppedId === null) {
        boolVal = true;
      }
      return boolVal;
    }, false);
    return hasUntouchedStep === true;
  }

  function DNDQHasNoUnsubmittedUpdates() {
    const hasUnsubmittedUpdates = props.sliders.reduce((boolVal, slider) => {
      if (slider.disable === false && slider.updated === true) {
        boolVal = true;
      }
      return boolVal;
    }, false);
    return hasUnsubmittedUpdates === false;
  }

  function OEQHasNoUnsubmittedUpdates() {
    const hasUnsubmittedUpdates = (props.responseArea !== props.savedResponse);
    return hasUnsubmittedUpdates === false;
  }

  function NEQHasNoUnsubmittedUpdates() {
    const hasUnsubmittedUpdates = (props.numericEntry !== props.savedEntry);
    return hasUnsubmittedUpdates === false;
  }

  function GroupedDNDQHasNoUnsubmittedUpdate() {
    const hasUnsubmittedUpdate = props.sliderGroups.reduce((boolVal, group) => {
      if (group.updated === true) {
        boolVal = true;
      }
      return boolVal;
    }, false);
    return hasUnsubmittedUpdate === false;
  }

  function MSCQHasUnsubmittedChanges() {
    const hasUnsubmittedChanges = props.checkboxes.reduce((boolVal, box) => {
      if (box.disabled === false && box.selected === true) {
        boolVal = true;
      }
      return boolVal;
    }, false);
    return hasUnsubmittedChanges === false;
  }

  return (
    <div className={props.className}>
      <span>Attempts left: {getTotalAttempts()}</span>
      {renderFeedback()}
      <SubmitButton
        uuid={props.uuid}
        submitAnswer={props.submitAnswer}
        componentID={props.id}
        disabled={isSubmitDisabled()}
        componentType={props.type}
        interactionProps={props.interactionProps}
        collectResponsesProps={ props.collectResponsesProps }
      />
    </div>
  );
}

QuestionFooter.propTypes = {
  complete: PropTypes.bool,
  type: PropTypes.string,
  options: PropTypes.array || PropTypes.any,
  groupedOptions1: PropTypes.array || PropTypes.any,
  groupedOptions2: PropTypes.array || PropTypes.any,
  savedResponse: PropTypes.string || PropTypes.any,
  answerSteps: PropTypes.array || PropTypes.any,
  slider: PropTypes.array || PropTypes.any,
  sliderGroups: PropTypes.array || PropTypes.any,
  totalAttempts: PropTypes.number,
  submitAnswer: PropTypes.func,
  id: PropTypes.number,
  showFeedback: PropTypes.bool,
};

export class SubmitButton extends React.Component {
  submit = () => {
    const {componentID, componentType} = this.props;
    let key = 'DNA A';
    this.props.submitAnswer(componentID, componentType, key);
    this.collectResponses();
  };

  collectResponses() {
    const { question, options, level, section, collectResponse } = this.props.collectResponsesProps;
    const uuid = this.props.uuid;

    if (!collectResponse) return

    const optionText = find(options, { selected: true }).text;

    const username = 'anonymous';
    const classField = 'anonymous';
    saveFeedbackToAirtable({ question: question.replace(/<[^>]+>/g, ''), feeback: optionText, level, section, username, classField, uuid });
  }

  render() {
    return (
      <Button
        className={this.props.disabled ? 'disabled' : ''}
        onClick={this.submit}
        disabled={this.props.disabled}>
        Submit answer
      </Button>
    );
  }
}

SubmitButton.propTypes = {
  submitAnswer: PropTypes.func,
  componentID: PropTypes.number,
  disabled: PropTypes.bool,
  componentType: PropTypes.string,
};

/* Function to check if CSCQ/CSCQ_COLOR component hasUnsubmitted options */
function CSCQHasUnsubmittedOption(options) {
  const hasUnsubmittedOption = options.reduce((boolVal, option) => {
    if (option.disabled === false && option.selected === true) {
      boolVal = true;
    }
    return boolVal;
  }, false);
  return hasUnsubmittedOption === false;
}

function GroupedCSCQHasUnsubmittedOption(options1, options2, answer1, answer2) {

  let override1 = false;
  let override2 = false;

  const hasUnsubmittedOption1 = options1.reduce((boolVal, option) => {
    if (
        (option.disabled === false && option.selected === true)
      ) {
      boolVal = true;
    }
    if (
        (option.selected && option.disabled && answer1 === option.id)
      ) {
      boolVal = true;
      override1 = true;
    }
    return boolVal;
  }, false);

  const hasUnsubmittedOption2 = options2.reduce((boolVal, option) => {
    if (
        (option.disabled === false && option.selected === true)
      ) {
      boolVal = true;
    }
    if (
        (option.selected && option.disabled && answer2 === option.id)
      ) {
      boolVal = true;
      override2 = true;
    }
    return boolVal;
  }, false);

  if(override1 && override2){
    return true;
  } else {
    return (!hasUnsubmittedOption1 && !hasUnsubmittedOption2);
  }
}
